import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { CapacitacionService } from 'src/app/services/capacitacion.service';
import { EventYearService } from 'src/app/services/event-year.service';
import { EventYearCalendarService } from 'src/app/services/event-yearCalendar.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';

//Borrar en caso de error
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours, } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, } from 'angular-calendar';
import { CategoryService } from "../../../services/category.service";
import { EnfoqueService } from "../../../services/enfoque.service";
import { EjecutorService } from "../../../services/ejecutor.service";
import { ZoneService } from "../../../services/zone.service";
import { LoginService } from 'src/app/services/login.service';


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#25e308',
    secondary: '#c7fdba',
  },
};
@Component({
  selector: 'app-calendar-view',
  changeDetection: ChangeDetectionStrategy.Default,
  styles: [
    `
      h3 {
        margin: 0 0 10px;
      }

      pre {
        background-color: #f5f5f5;
        padding: 15px;
      }
    `,
  ],
  templateUrl: './calendar-view.component.html',
  styleUrls: ['./calendar-view.component.scss']
})
export class CalendarViewComponent implements OnInit {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  locale: string = 'es';
  creationMode: string;
  categoriesWithFocos: any;
  workersSelected = [];
  enfoques: any;
  ejecutoresWithRelatores: any;
  zonas: any;
  loading = false;
  listStatus: any = [];
  calendario: CalendarEvent[] = [];
  rolid: any;
  refresh = new Subject<void>();
  events: CalendarEvent[];
  activeDayIsOpen: boolean = false;
  cantidadCapacitaciones: number;
  datosCapacitacion: any;

  constructor(private navigationService: NavigationService,
    private capacitacionService: CapacitacionService,
    private eventYearCalendarService: EventYearCalendarService,
    private eventEmitterService: EventEmitterService,
    private modalService: NgbModal,
    private categoryService: CategoryService,
    private enfoqueService: EnfoqueService,
    private ejecutorService: EjecutorService,
    private zoneService: ZoneService,
    private modal: NgbModal,
    private loginService: LoginService) {
    this.eventEmitterService.invokeCalendarRefresh.subscribe({
      next: (event: any) => {
        console.log(`Received message`);
        this.getCapacitacionesCalendario()
      }
    })
  }

  async ngOnInit() {
    await this.loginService.obtenerPermisosMenu('planificacion').then((response) => {
      this.rolid = response.data.rolId
    })
    $("#show-loading").css('display', 'grid')
    this.getCapacitacionesCalendario();

  }

  ngOnDestroy() {

  }

  getCapacitacionesCalendario(): void {
    $("#show-loading").css('display', 'grid')
    this.events = [];
    this.calendario = [];
    this.activeDayIsOpen = false;
    this.refresh.next();

    this.capacitacionService.getCapacitacionesCalendario(parseInt(sessionStorage.getItem('userid')), parseInt(this.rolid))
      .then(response => {
        for (let o of response) {
          let categoriaId = "";
          let titulo = "";
          if (this.rolid == 1 || this.rolid == 2) {
            categoriaId = o.categoryId;
            titulo = o.capacitacionTypeDescription + ": " + o.name + "(Plan Asociado : " + o.planCapacitacion + ") Estado : " + o.stateShortDescription;
          } else {
            categoriaId = o.categoryId;
            titulo = o.capacitacionTypeDescription + ": " + o.name + " Estado : " + o.stateShortDescription;
          }
          let fecha = o.fecha.split("-");
          let currentTime = new Date()
          let month = currentTime.getMonth() + 1
          let year = currentTime.getFullYear()
          let fechaActual = new Date(year, month);
          let fechaCapacitacion = new Date(fecha[2], fecha[1]);

          let estado = 1;


          if (o.stateId == 5 || o.stateId == 7 || o.stateId == 8) {
            estado = 2
          }


          let array: any = {
            id: categoriaId,
            start: startOfDay(new Date(fecha[2], fecha[1] - 1, fecha[0])),
            title: titulo,
            color: estado == 1 ? colors.red : (estado == 2) ? colors.green : colors.blue,
            month: fecha[1],
            statusCapacitacion: o.stateShortDescription
          }

          this.calendario.push(array);
        }
        this.events = this.calendario;
        this.refresh.next();
        $("#show-loading").css('display', 'none')
      })
      .catch(error => {
        $("#show-loading").css('display', 'none')
        error = true;
      });
  }

  modalData: {
    action: string;
    event: CalendarEvent;
  };
  changeView(viewdate: Date) {
    this.viewDate = viewdate;
  }
  getEjecutores(): any {
    return new Promise((resolve, reject) => {
      this.ejecutorService.listWithRelatores()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getZonas(): any {
    return new Promise((resolve, reject) => {
      this.zoneService.getZonas()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getAsistentes(capacitacionId: number): any {
    return new Promise((resolve, reject) => {
      this.capacitacionService.getAsistentes(capacitacionId)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getEnfoques(id: number): any {

    this.enfoqueService.enfoqueById(id)
      .then(response => {
        let resp: any = response;

        this.listStatus = resp;
      })
      .catch(error => {
        error = true;
      });
    return new Promise((resolve, reject) => {
      this.enfoqueService.enfoqueById(id)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getCategories(id: number): any {
    this.categoryService.getByIdCategorias(id)
      .then(response => {

        let resp: any = response;
        this.listStatus = resp;
      })
      .catch(error => {
        error = true;
      });
    return new Promise((resolve, reject) => {
      this.categoryService.getByIdCategorias(id)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getCategoriesAll(): any {
    return new Promise((resolve, reject) => {
      this.categoryService.listWithFocos()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  getEnfoquesAll(): any {
    return new Promise((resolve, reject) => {
      this.enfoqueService.list()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  onSave(): void {
    this.getCapacitacionesCalendario()
    this.eventEmitterService.onFirstComponentButtonClick();
    this.eventEmitterService.onIndicatorsRefresh();



  }
  onSaveAccept(): void {
    this.getCapacitacionesCalendario();
    this.eventEmitterService.onFirstComponentButtonClick();
    this.eventEmitterService.onIndicatorsRefresh();

  }

  openModal(modal: any, mode: string, event: any): void {
    this.loading = true;
    console.log('Evento desde el calendario')
    console.log(event)
    $("#show-loading").css('display', 'grid')
    this.getCapacitacion(Number(event.id), event.statusCapacitacion)
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    // Promise.all([
    //   this.getCategories(id),
    //   this.getEnfoques(id),
    //   this.getEjecutores(),
    //   this.getZonas(),
    // ])
    Promise.all([
      this.getCategoriesAll(),
      this.getEnfoquesAll(),
      this.getEjecutores(),
      this.getZonas(),
      this.getAsistentes(event.id)
    ])
      .then(results => {
        this.categoriesWithFocos = results[0];
        this.enfoques = results[1];
        this.ejecutoresWithRelatores = results[2];
        this.zonas = results[3];
        this.workersSelected = results[4];
        this.creationMode = mode;
        this.loading = false;
        $("#show-loading").css('display', 'none')
        this.modalService.open(modal, modalOptions);

      })
      .catch(error => {
        console.error(error)
        $("#show-loading").css('display', 'none')
      });

  }
  getCapacitacion(id: number, statusCapacitacion: string): any {
    this.capacitacionService.getCapacitacion(id)
      .then(response => {
        this.datosCapacitacion = response;
        this.datosCapacitacion.statusCapacitacionLabel = statusCapacitacion;
      })
      .catch(error => {

        console.error(error);
      });
  }
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.cantidadCapacitaciones = events.length;
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

}
